import React from 'react';
import EvidenceCard from './EvidenceCard';

/**
 * Visa Status 카드
 *
 * States:
 *   - visa = null/undefined  → text: "Add your visa to check your eligibility."
 *   - visa.expired = false   → chip: visa.type (active)
 *   - visa.expired = true    → chip: "Expired" (inactive)
 *
 * @param {{ type: string, expired?: boolean } | null} visa
 */
function VisaStatusCard({
  visa,
  chips: chipsProp,
  onUpdate,
  onCheckEligibility,
  evidenceItems,
  sessionId,
  initialScore,
  onEvidenceSave,
  className,
}) {
  const chips = chipsProp || (visa
    ? [{ label: visa.expired ? 'Expired' : visa.type, inactive: visa.expired }]
    : undefined);

  return (
    <EvidenceCard
      color='green'
      title='Visa Status'
      chips={chips}
      statusText='Add your visa to check your eligibility.'
      secondaryLabel='Update'
      primaryLabel='Check eligibility'
      onSecondaryClick={onUpdate}
      onPrimaryClick={onCheckEligibility}
      evidenceItems={evidenceItems}
      sessionId={sessionId}
      initialScore={initialScore}
      onEvidenceSave={onEvidenceSave}
      className={className}
    />
  );
}

export default VisaStatusCard;
